import { createTheme } from "@mui/material/styles";
import { useQueryAppConfiguration } from "./appConfiguration/useQueryAppConfiguration";

export function useGetTheme() {
  const { data: configObj, isLoading } = useQueryAppConfiguration();

  const theme = createTheme({
    palette: {
      mode: "light",
      primary: {
        main: configObj.mainButtonColor ?? "#1976d2", //"#f2987a",
        contrastText: configObj.mainButtonTextColor ?? "#ffffff",
      },
      neutral: {
        main: "rgb(170, 170, 170)",
        contrastText: "#ffffff",
      },
      danger: {
        main: "rgb(255, 0, 0)",
        contrastText: "#ffffff",
      },
      filters: {
        main: "#ffb800",
      },
    },
    components: {
      MuiSlider: {
        styleOverrides: {
          valueLabel: {
            top: 54,
          },
        },
      },
    },
  });

  return theme;
}
